import type { OnFileAdded, UUID } from '@pixum/types';
import type { ImageStateUpdater } from '../../../../types/expressDesigner';

export function onFileAdded(updater: ImageStateUpdater): OnFileAdded {
  return (clientId: UUID) =>
    updater.updateImage({
      uuid: clientId,
      id: clientId,
      isUpload: true,
    });
}
